import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import Loader from "../Component/Loader";
import NonAuthLayout from "../Layout/NonAuthLayout";
import { protectedRoutes, publicRoutes } from "./AllRoutes";
import { AuthProtected } from "./AuthProtected";

import "../assets/css/Theme/node-waves.css";
import "../assets/css/Theme/pickr-themes.css";
import "../assets/css/Theme/core.css";
import "../assets/css/Theme/demo.css";
import "../assets/css/Theme/prefect-scrollbar.css";
import "../assets/css/Theme/apex-charts.css";
import "../assets/css/Theme/swiper.css";
import "../assets/css/Theme/datatables-bootstrap.css";
import "../assets/css/Theme/responsive-bootstrap5.css";
import "../assets/css/Theme/card-advance.css";
import "../assets/css/Theme/page-auth.css";

const Index = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        {/* Public Routes */}
        <Route element={<NonAuthLayout />}>
          {publicRoutes.map((route, idx) => (
            <Route path={route.path} element={<route.component />} key={idx} />
          ))}
        </Route>

        {/* Protected Routes */}
        <Route element={<AuthProtected />}>
          {protectedRoutes.map((route, idx) => (
            <Route path={route.path} element={<route.component />} key={idx} />
          ))}
        </Route>
      </Routes>
    </Suspense>
  );
};

export default Index;
